import { useState } from "react";
import { Box, Divider, Grid2, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import ModeButton from "./ModeButton";
import ScheduleButton from "./ScheduleButton";
import { SaveChangesButton } from "./SaveChangesButton";
import { RevertAllChangesButton } from "./RevertAllChangesButton";
import { getPlatform, useScreenOrientation } from "../../../utilities/orientationAndPlatform";


export default function SubHeaderBar({...params}){

    let pageMode = params.pageMode
    let setPageMode = params.setPageMode
    let channelData = params.channelData
    let isLive = params.isLive
    let logoURLState = params.logoURLState
    let userCanEdit = params.userCanEdit
    let handleSaveAllChangesClick = params.handleSaveAllChangesClick
    let handleRevertAllChangesClick = params.handleRevertAllChangesClick
    let updatedFieldsCountState = params.updatedFieldsCountState
    let theme = useTheme()
    let orientation = useScreenOrientation()

    let [modeButtonState, setModeButtonState] = useState('default')
    let [revertButtonState, setRevertButtonState] = useState('default')
    let [saveButtonState, setSaveButtonState] = useState('default')
    let [infoButtonState, setInfoButtonState] = useState('default')
    let [scheduleButtonState, setScheduleButtonState] = useState('default')

    function loadStationLogo(e) {
        e.target.onError = null;
        e.target.style.backgroundColor = '#007CEB';
        e.target.src = "/logos/sinclair-broadcast-group-white.svg";
    }

    let isNarrowDesktop = useMediaQuery('(max-width:1246px)')
    let platform = getPlatform()
    let subHeaderStackDirection = ''
    let subHeaderStackSpacing = ''
    let logoAlignment = ''
    let dividerVariant = ''
    if ((platform === 'mobile' && orientation === 0) || (platform === 'desktop' && isNarrowDesktop)) {
        subHeaderStackDirection = 'column'
        subHeaderStackSpacing = '15px'
        logoAlignment = 'center'
    }
    else if (platform === 'desktop' || (platform === 'mobile' && orientation === 90)) {
        subHeaderStackDirection = 'row'
        subHeaderStackSpacing = '20px'
    }

    let fontColor = theme.palette.ChannelPage.subheader.fontdefault

    return (
        <Grid2 position={'sticky'} top={'95px'} zIndex={10} display={'flex'} justifyContent={'center'} width={'100%'} backgroundColor={'ChannelPage.subheader.background'} sx={{borderBottom: '1px solid ' + theme.palette.ChannelPage.subheader.divider}} id={'SubHeaderBarGrid'}>
            
            <Stack direction={subHeaderStackDirection} spacing={subHeaderStackSpacing}>
                <Box align={logoAlignment} height={'70px'}>
                    <Box
                        component="img"
                        src={logoURLState.imageSrc + '?' + logoURLState.imageHash + '.svg'}
                        alt="Station Logo"
                        onError={loadStationLogo}
                        sx={{
                            backgroundColor: "#007CEB",
                            padding: "15px",
                            height: "70px",
                            width: "182px",
                        }}
                    />
                </Box>

                {((platform === 'mobile' && orientation === 0) || (platform === 'desktop' && isNarrowDesktop)) ? (
                    <>
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} alignItems={'center'} width={'100%'}>
                            <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400} paddingRight={'21px'}>{channelData.call_sign}</Typography>
                            <Divider orientation={'vertical'} flexItem variant={dividerVariant} sx={{backgroundColor: 'ChannelPage.subheader.mobiledivider'}} />
                            <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400} paddingLeft={'21px'} paddingRight={'21px'}>{channelData.affiliation}</Typography>
                            <Divider orientation={'vertical'} flexItem variant={dividerVariant} sx={{backgroundColor: 'ChannelPage.subheader.mobiledivider'}} />
                            <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400} paddingLeft={'21px'}>{channelData.market}</Typography>
                        </Box>

                        <ScheduleButton pageMode={pageMode} setPageMode={setPageMode} isLive={isLive} infoButtonState={infoButtonState} setInfoButtonState={setInfoButtonState} scheduleButtonState={scheduleButtonState} setScheduleButtonState={setScheduleButtonState}/>
                        {(userCanEdit) && (
                            <Stack direction={'row'} spacing={3} alignSelf={'center'} paddingBottom={'17px'}>
                                <ModeButton pageMode={pageMode} setPageMode={setPageMode} modeButtonState={modeButtonState} setModeButtonState={setModeButtonState}></ModeButton>
                                {(pageMode === 'edit') && (
                                    <>
                                        <SaveChangesButton handleSaveAllChangesClick={handleSaveAllChangesClick} updatedFieldsCountState={updatedFieldsCountState} saveButtonState={saveButtonState} setSaveButtonState={setSaveButtonState}/>
                                        <RevertAllChangesButton handleRevertAllChangesClick={handleRevertAllChangesClick} updatedFieldsCountState={updatedFieldsCountState} revertButtonState={revertButtonState} setRevertButtonState={setRevertButtonState}/>
                                    </>
                                )}
                            </Stack>
                        )}
                    </>
                )

                :(platform === 'desktop' || (platform === 'mobile' && orientation === 90)) && (
                    <>
                        <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400}>{channelData.call_sign}</Typography>
                        <Divider orientation={'vertical'} sx={{backgroundColor: 'ChannelPage.subheader.desktopdivider'}} />
                        <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400}>{channelData.affiliation}</Typography>
                        <Divider orientation={'vertical'} sx={{backgroundColor: 'ChannelPage.subheader.desktopdivider'}} />
                        <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400}>{channelData.market}</Typography>
                        <Divider orientation={'vertical'} sx={{backgroundColor: 'ChannelPage.subheader.desktopdivider'}} />
                        <ScheduleButton pageMode={pageMode} setPageMode={setPageMode} isLive={isLive} infoButtonState={infoButtonState} setInfoButtonState={setInfoButtonState} scheduleButtonState={scheduleButtonState} setScheduleButtonState={setScheduleButtonState}></ScheduleButton>
                        <Divider orientation={'vertical'} sx={{backgroundColor: 'ChannelPage.subheader.desktopdivider'}} />
                        {(userCanEdit) && (
                            <Stack direction={'row'} spacing={3} alignSelf={'center'}>
                                <ModeButton pageMode={pageMode} setPageMode={setPageMode} modeButtonState={modeButtonState} setModeButtonState={setModeButtonState}></ModeButton>
                                {(pageMode === 'edit') && (
                                    <>
                                        <SaveChangesButton handleSaveAllChangesClick={handleSaveAllChangesClick} updatedFieldsCountState={updatedFieldsCountState} saveButtonState={saveButtonState} setSaveButtonState={setSaveButtonState}/>
                                        <RevertAllChangesButton handleRevertAllChangesClick={handleRevertAllChangesClick} updatedFieldsCountState={updatedFieldsCountState} revertButtonState={revertButtonState} setRevertButtonState={setRevertButtonState}/>
                                    </>
                                )}
                            </Stack>
                        )}
                    </>
                )}
            </Stack>
        </Grid2>
    )
}
